// Use-case tag filter for the horizontal collection toolbar.
//
// The funnel button expands the toolbar with a second row of tag badges
// (classic /collections/handle/tag filtering, so the actual filtering is
// server-side); the close button collapses it. A custom element so the
// behaviour survives the theme's morphed page transitions and the
// results-list section re-renders.

class UseCaseFilter extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.toggle = this.querySelector('[data-usecase-toggle]');
    this.strip = this.querySelector('[data-usecase-strip]');
    if (!this.toggle || !this.strip) return;

    this.toggle.addEventListener('click', () => this.#setOpen(!this.classList.contains('is-open')));
    this.querySelector('[data-usecase-close]')?.addEventListener('click', () => this.#setOpen(false));

    // Badge taps swap the product grid in place (Section Rendering API)
    // instead of a full page load. The URL still updates, so filtered views
    // stay shareable and the back button works.
    this.strip.addEventListener('click', (event) => {
      const link = event.target.closest('a.usecase-badge');
      if (!link) return;
      event.preventDefault();
      this.#applyFilter(link.href);
    });
  }

  #setOpen(open) {
    this.classList.toggle('is-open', open);
    this.toggle.setAttribute('aria-expanded', String(open));
    if (open) this.strip.querySelector('a')?.focus({ preventScroll: true });
  }

  async #applyFilter(url) {
    const sectionEl = this.closest('.shopify-section');
    const sectionId = sectionEl?.id?.replace('shopify-section-', '');
    if (!sectionId) {
      window.location.href = url;
      return;
    }

    sectionEl.style.opacity = '0.5';
    sectionEl.style.transition = 'opacity 160ms ease';

    try {
      const separator = url.includes('?') ? '&' : '?';
      const response = await fetch(`${url}${separator}section_id=${sectionId}`);
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById(sectionEl.id) || doc.body.firstElementChild;
      if (!fresh) throw new Error('empty section response');

      sectionEl.replaceWith(fresh);
      window.history.pushState({}, '', url);

      // The replacing markup renders the strip open only when a tag filter is
      // active; the visitor was mid-filtering either way, so keep it open.
      const next = fresh.querySelector('use-case-filter');
      if (next && !next.classList.contains('is-open')) {
        next.classList.add('is-open');
        next.querySelector('[data-usecase-toggle]')?.setAttribute('aria-expanded', 'true');
      }
    } catch (error) {
      window.location.href = url;
    }
  }
}

if (!customElements.get('use-case-filter')) {
  customElements.define('use-case-filter', UseCaseFilter);
}
